export const DISTRIBUTOR_NAME = 'DISTRIBUTOR_NAME'
export const DISTRIBUTOR_HASSUB = 'DISTRIBUTOR_HASSUB'
export const DISTRIBUTOR_HASSUBRETURN = 'DISTRIBUTOR_HASSUBRETURN'
export const DISTRIBUTOR_SUBRETURNMODE = 'DISTRIBUTOR_SUBRETURNMODE'
export const ADD_ERROR_LOG = 'ADD_ERROR_LOG'
export const DISTRIBUTOR_INFO = 'DISTRIBUTOR_INFO'
